import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from "reactstrap";
import { parseApiError } from "@yooink/youtils/es/ParseApiError";
import Button from "reactstrap/es/Button";
export function errorRenderer({ errData, run }) {
    return (_jsxs(Alert, Object.assign({ color: 'danger' }, { children: [_jsx("p", { children: parseApiError(errData) }), _jsx(Button, Object.assign({ onClick: run, color: 'primary' }, { children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C" }))] })));
}
